import React, { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchField, ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { ioFlagDs, tradeTypeDs, billCancelStatusDs, billStatusDs, rechargeStatus } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { useBillRechargeLogModel } from "../billRechargeLogModel";

export function PageHeader() {
    const {
        orgDs,
        beDs,
        searchParam,
        resetSearchParam,
        updateSearchParam,
        loadData,
        customerUserDs
    } = useBillRechargeLogModel();
    const {fetchCustomerList, unit,fetchSupplierList, user: { shopCode } } = useGlobalModel()


    const searchFields: ISearchField[] = [
        // {
        //     type: SearchTypeEnum.CheckBox,
        //     xxl: 3,
        //     span: 3,
        //     placeholder: "供应商",
        //     fieldName: "supplier",
        //     size: "small"
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "客户/供应商",
            fieldName: "supplier",
            size: "small",
            disabled: false,
            options: [{label:'客户',value:'0'},{label:'供应商',value:'1'}],
        },
        ...[searchParam.supplier === "1" ? {
            type: SearchTypeEnum.AsyncSelect,
            key: "supplier",
            xxl: 4,
            span: 4,
            placeholder: "供应商",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchSupplierList,
        } : {
            type: SearchTypeEnum.AsyncSelect,
            key: "customer",
            xxl: 4,
            span: 4,
            placeholder: "客户",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchCustomerList,
        }],
        // {
        //     type: SearchTypeEnum.AsyncSelect,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "客户",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     selectfetchList: fetchCustomerList,
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "审核状态",
            fieldName: "statusList",
            size: "small",
            disabled: false,
            options: rechargeStatus,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "实体",
            fieldName: "beCode",
            size: "small",
            disabled: false,
            options: beDs,
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
        },


    ]
    const searchMoreFields: ISearchField[] = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "备注",
            fieldName: "note",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.TreeSelect,
            xxl: 4,
            span: 4,
            placeholder: "机构",
            fieldName: "orgCode",
            size: "small",
            disabled: false,
            treeDs: orgDs,
        },
    ]
    return (
        <YhPageHeader
            title="充值记录总览"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            searchMoreFields={searchMoreFields}
            triggerSearch={false}
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}